import { UsageTypeList } from '@zurich/api/contract';
import { createArrayUtils, UnknownType } from '@zurich/common/utils';
export const usageTypeUtils = createArrayUtils(UsageTypeList, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'contract:usageType',
    createDefaultValue: () => 'ownUse',
});
